var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeloVip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.51 44.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "selo_vip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.73,28.94v16l8.51-4.73V31.67A14.54,14.54,0,0,1,8.73,28.94Z",
    transform: "translate(0 0.01)",
    fill: "#red",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.24,31.67v8.51l8.51,4.73v-16A14.56,14.56,0,0,1,17.24,31.67Z",
    transform: "translate(0 0.01)",
    fill: "#385799",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.09 12.05 20.09 10.63 14.42 10.63 14.42 12.05 16.31 12.05 16.31 21.99 14.42 21.99 14.42 23.41 20.09 23.41 20.09 21.99 18.2 21.99 18.2 12.05 20.09 12.05",
    fill: "#e49a61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.55,5.72c8.83-2.55,7.54-3.62,6.57,5.51,8.41,3.73,8.12,2.08,1.5,8.46,4,8.26,4.88,6.8-4.29,7.44-2.21,8.92-.63,8.35-8.07,2.93-7.44,5.42-5.86,6-8.07-2.93C0,26.49.86,28,4.9,19.69-1.72,13.31-2,15,6.39,11.23,5.43,2.09,4.14,3.17,13,5.71c5.14-7.63,3.45-7.63,8.59,0Z",
    transform: "translate(0 0.01)",
    fill: "#FFD700",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.26,28.32A10.88,10.88,0,1,1,28.13,17.44,10.89,10.89,0,0,1,17.26,28.32Zm0-19.86a9,9,0,1,0,9,9A9,9,0,0,0,17.26,8.46Z",
    transform: "translate(0 0.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.76 23.43 13.3 14.61 12.17 14.61 12.17 13.65 16.03 13.65 16.03 14.61 14.87 14.61 17.27 20.91 19.75 14.61 18.47 14.61 18.47 13.65 22.34 13.65 22.34 14.61 21.2 14.61 17.68 23.43 16.76 23.43",
    fill: "#7d7125"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeloVip);
export default __webpack_public_path__ + "static/media/selo_vip.f1f18e33c238efbaad22a60616d6320e.svg";
export { ForwardRef as ReactComponent };